<template>
    <ion-toolbar class="relative">
        <ion-buttons
            v-if="headerDefinition.showBackButton"
            class="absolute left-1 flex items-center"
            slot="start"
        >
            <ion-button
                class="back-button"
                @click="goBack"
            >
                <ion-icon :icon="chevronBackOutline" />
            </ion-button>
        </ion-buttons>
        <ion-title class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center">
            <div class="flex justify-around h-full">
                <div>
                    {{ headerDefinition.title }}
                </div>
            </div>
        </ion-title>
        <ion-buttons
            v-if="headerDefinition.showConfirmButton"
            class="absolute right-1 flex items-center"
            slot="end"
        >
            <ion-button @click="headerDefinition.confirmCallback?.()">
                {{ headerDefinition.confirmButtonText }}
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</template>

<script
    setup
    lang="ts"
>
import { useHeaderStore } from '@/store/header.ts';
import { IonButton, IonButtons, IonIcon, IonTitle, IonToolbar } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';

const router = useRouter();
const { headerDefinition } = useHeaderStore();

const goBack = () => {
    if (headerDefinition.goBackRoute) {
        router.push(headerDefinition.goBackRoute);
    } else {
        router.go(-1);
    }
};

</script>

<style scoped>
ion-title {
    padding-inline-start: 0;
    padding-inline-end: 0;
}

ion-button {
    --color: var(--action-button-color) !important;
    --color-activated: var(--action-button-color) !important;
    --color-focused: var(--action-button-color) !important;
    --color-hover: var(--action-button-color) !important;
    cursor: pointer;
}

ion-toolbar {
    --background: var(--header-footer-background, #ECECEC);
}
</style>